import { apiBaseUrl as baseUrl, fetch as http } from "./http";

// ─── Services ─────────────────────────────────────────────────────────────────

/**
 * Fetches all locations along with their user status.
 */
export const getAllLocationsWithUserStatusService = async (payload?: { user_id?: string | number }) => {
  const params = payload?.user_id ? `?user_id=${payload.user_id}` : "";
  const data = await http.Get(`/get-all-locations-with-user-status${params}`);
  return data;
};

